import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {MerchantCard, MerchantCardStyle} from "../../../ui/MerchantCard";
import {WidgetActiveRouteElementBuilder} from "../../../ui/WidgetActiveRouteElement";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {SubscriptionIndex} from "./SubscriptionIndex";
import {DonationOverview} from "./DonationOverview";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {Color} from "../../../../../stem-core/src/ui/Color";
import {AddFundsMinimised} from "../../add-funds/sections/AddFundsMinimised";
import {Messages} from "../../../../Messages";
import {DEFAULT_TRANSITION_TIME_MS} from "../../../../../blink-sdk/Constants";
import {MerchantLogo} from "../../../../common/MerchantLogo.jsx";


class IndexHomeStyle extends MerchantCardStyle {
    @styleRule
    buttonContainer = {};

    @styleRule
    subscriptionBordered = {
        borderBottom: "0.5px solid " + Color.addOpacity("#545f69", 0.12),
    };

    @styleRule
    emptyDescription = {
        paddingTop: 6,
        fontSize: 16,
        lineHeight: 24,
        textAlign: "center",
        color: "#555555",
    };
}

@registerStyle(IndexHomeStyle)
export class IndexHome extends WidgetActiveRouteElementBuilder(MerchantCard) {
    renderHeaderSection() {
        return <MerchantLogo/>;
    }

    render() {
        if (!iFrameMerchantService.getMerchant().allowSubscriptions && !iFrameMerchantService.getMerchant().allowDonations) {
            return <div className={this.styleSheet.emptyDescription}>{Messages.emptyIndexExpandedDescription}</div>;
        }
        return [
            this.renderSubscriptionSection(),
            this.renderDonationSection()
        ];
    }

    renderSubscriptionSection() {
        if (!iFrameMerchantService.getMerchant().allowSubscriptions) {
            return null;
        }

        return <SubscriptionIndex className={iFrameMerchantService.getMerchant().allowDonations ?
                                             this.styleSheet.subscriptionBordered : ""}/>;
    }

    renderDonationSection() {
        if (!iFrameMerchantService.getMerchant().allowDonations) {
            return null;
        }

        return <DonationOverview />;
    }

    renderSecondaryButton() {
        return null;
    }

    static show() {
        const {instance} = this;
        instance.redraw();
        instance.attachTimeout(() => instance.checkForScrollFadeDisplay(), DEFAULT_TRANSITION_TIME_MS);
    }

    computeHeight() {
        return this.getHeight() + AddFundsMinimised.getHeight();
    }
}
